import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthStore } from "../../hooks";
import { useWorkOrderStore } from "../../hooks/useWorkOrderStore";
import { Role } from "../../types/roles/roleTypes";
import { RoutesMap } from "../../types";
import { Grid, IconButton, Typography, Button } from "@mui/material";
import { ApiStatus } from "../../types/api/status";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { WorkOrderSignatureModal } from "./WorkOrderSignatureModal";

export const WorkOrderSignature:FC = () => {

    const navigate = useNavigate()
    const { user } = useAuthStore()
    const params = useParams()
    const { status, workOrders, getWorkOrderPDF, getOneWorkOrder } = useWorkOrderStore()
    

    const [pdf, setPDF] = useState<any>(null)
    const [signed, setSigned] = useState<boolean>(false)
    const [showModalFirm, setShowModalFirm] = useState<boolean>(false)

    const { id } = params
    const idworkOrder:any = id
    const userRole:Role|any = user.userType;

    useEffect(()=>{
        setLocalData()
    },[])

    
    useEffect(()=>{
        console.log('signed', signed)
    },[signed])

    useEffect(()=>{
        if (workOrders[0] && Object.entries(workOrders[0]).length > 0) {
            if (userRole === Role.MECHANIC && workOrders[0].status_mechanic === '1') {
                setSigned(true)
            }
            if (userRole === Role.MAINTENANCE && workOrders[0].status_boss === '1') {
                setSigned(true)
            }
        }
    },[workOrders])

    const setLocalData = async () => {
        await getOneWorkOrder(idworkOrder)
        showPDF(idworkOrder)
    }

    const handleBack = () => {
        navigate({ pathname: RoutesMap.WORK_ORDER_LIST })
    }

    const showPDF = async (id) => {
        const pdf = await getWorkOrderPDF(id)
        const blob = new Blob([pdf], { type: 'application/pdf' })
        const bloblURL = URL.createObjectURL(blob)
        setPDF(bloblURL)
    }

    return (
        <Grid container>
            {status === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            <Grid item xs={12} display='flex' alignItems='center' sx={{ marginLeft: '-25px' }}>
                <IconButton size="small" color="primary" aria-label="view" onClick={() => handleBack()}>
                    <ArrowBackIcon fontSize='small' />
                </IconButton>
                <Typography>Volver</Typography>
            </Grid>
            <Grid item container sx={{ alignItems: "center", display: "flex", justifyContent: "center", flexWrap: "wrap", marginBottom: "10px" }}>
                <Typography variant="h6" component="h1" gutterBottom color="#808080" className="tittle" sx={{ mt: 1, ml: 1, fontWeight: 600 }}>
                    ORDEN DE TRABAJO
                </Typography>
            </Grid>
            {
                !signed && (userRole === Role.MECHANIC || userRole === Role.MAINTENANCE) && workOrders[0].status_det == '1' && workOrders[0].status_ast == '1' && (
                    <Grid item xs={12} sx={{ textAlign: "right" }}>
                        <Button
                            onClick={() => setShowModalFirm(true)}
                            sx={{ border: "solid 1px #73B2FF", m: "10px", color: "#73B2FF", width: '150px', "&:hover": { bgcolor: "#73B2FF", color: "#fff" } }}
                        >
                            FIRMAR
                        </Button>
                    </Grid>
                )
            }
            <Grid container style={{ overflow: 'hidden !important', height: '100%', alignItems: 'center', textAlign: 'center' }}>
                <iframe src={pdf} id="pdfVer" height="1000px" width="100%"></iframe>
            </Grid>
            {
                showModalFirm && (
                    <WorkOrderSignatureModal
                        open={showModalFirm}
                        closeModal={() => setShowModalFirm(false)}
                        idworkOrder={idworkOrder}
                    />
                )
            }
        </Grid>
    )
}